/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Create_Source_CsvInputs */

const en_statement_tree_create_source_csv = /** @type {(inputs: Statement_Tree_Create_Source_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imported CSV`)
};

const nl_statement_tree_create_source_csv = /** @type {(inputs: Statement_Tree_Create_Source_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geïmporteerde CSV`)
};

/**
* | output |
* | --- |
* | "Imported CSV" |
*
* @param {Statement_Tree_Create_Source_CsvInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_create_source_csv = /** @type {((inputs?: Statement_Tree_Create_Source_CsvInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Create_Source_CsvInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_create_source_csv(inputs)
	return en_statement_tree_create_source_csv(inputs)
});